(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function ($) {
    $(".owl-carousel").each(function () {
      const $owl = $(this);
      const id = $owl.data("id");

      // Initialize each carousel separately
      $owl.owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        autoplay: false,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
          0: { items: 1,loop: true,},
          1024: { items: 3,loop: true,},
          1199: { items: 5,loop: true, },
          1600: { items: 6,loop: true,}
        }
      });

      // Next/Prev button logic for each data-id
      $(`.next-btn[data-id='${id}']`).click(function () {
        $owl.trigger("next.owl.carousel");
      });
      $(`.prev-btn[data-id='${id}']`).click(function () {
        $owl.trigger("prev.owl.carousel");
      });

      // Optional: handle disable state updates
      $owl.on("translated.owl.carousel initialized.owl.carousel", function (event) {
        const $prevBtn = $(`.prev-btn[data-id='${id}']`);
        const $nextBtn = $(`.next-btn[data-id='${id}']`);

        const carousel = event.relatedTarget;
        const current = carousel.current();
        const total = carousel.items().length;

        // Disable prev button if at the first item
        if (current === 0) {
          $prevBtn.addClass("disabled");
        } else {
          $prevBtn.removeClass("disabled");
        }

        // Disable next button if at the last visible item
        if (current + carousel.settings.items >= total) {
          $nextBtn.addClass("disabled");
        } else {
          $nextBtn.removeClass("disabled");
        }
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
